import { render } from "./AdminMainView.vue?vue&type=template&id=7413afe5"
import script from "./AdminMainView.vue?vue&type=script&lang=js"
export * from "./AdminMainView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__